import React from 'react'
import { Modal } from 'antd'
import { messageTypes } from '../../../../actions/messages'
import { takeElementWithIdFromArr, openNotificationPopup, getCookie } from '../../../../actions/helpers'
import StyledMachinesForm from '../../../../styledComponents/sections/settings/machines/machinesForm'
import { machinesGetVmwareForStackType } from '../../../../actions/'

class MachinesModalSettings extends React.Component {
  state = {
    singleData: {},
    singleDataVmware: undefined,
    machines: undefined
  }

  handleCancel = () => {
    const { setDataId, showAddRecordModal } = this.props
    setDataId(null)
    showAddRecordModal(false)
  }

  componentDidUpdate (prevProps, prevState) {
    const { dataId, data } = this.props
    if (prevProps.dataId !== dataId) {
      if (dataId === null) {
        this.setState({ singleData: null, singleDataVmware: undefined, machines: undefined })
      } else {
        const singleData = takeElementWithIdFromArr(dataId, data)

        if (singleData?.stack_types) {
          this.getMachinesForStackTypes(singleData?.machine_name, singleData?.stack_types)

          this.setState({ singleData })
        } else {
          this.setState({ singleData, machines: [] })
        }
      }
    }
  }

  getMachinesForStackTypes = (machineName, stackTypes) => {
    const promises = []

    for (const stackType of stackTypes) {
      promises.push(this.getMachinesVmwareForStackType(stackType))
    }

    Promise.all(promises).then((values) => {
      const machines = values.flat()
      const singleDataVmware = machines.find(x => x.name.toLowerCase() === machineName)

      this.setState({
        machines,
        singleDataVmware
      })
    })
  }

  getMachinesVmwareForStackType = (stackType) => {
    const { language } = this.props

    return new Promise(function (resolve, reject) {
      machinesGetVmwareForStackType(getCookie('_token'), stackType).then((json) => {
        if (json.status === 'ok') {
          resolve(json.response)
        } else if (json.status === 'err') {
          openNotificationPopup(messageTypes[language].oops, json.response[language], 'frown')
          reject(new Error('cannot get machines for stack type'))
        }
      })
    })
  }

  render () {
    const {
      language, dataId, isNewRecord, loading,
      updateRecord, addRecord
    } = this.props
    const { singleData, singleDataVmware, machines } = this.state
    return (
      <div>
        <Modal
          maskClosable={false}
          width={1000}
          visible={!!(dataId || isNewRecord)}
          title={
            (isNewRecord && messageTypes[language].new_machine) ||
            (
              singleData &&
              singleData.name &&
              singleData.name[language])
          }
          onCancel={this.handleCancel}
          footer={null}
        >
          <StyledMachinesForm
            machines={machines}
            isNewRecord={isNewRecord}
            data={singleData || {}}
            singleDataVmware={singleDataVmware}
            language={language}
            onCancel={this.handleCancel}
            updateRecord={updateRecord}
            addRecord={addRecord}
            loading={loading}
            getMachinesForStackTypes={this.getMachinesForStackTypes}
          />
        </Modal>
      </div>
    )
  }
}

export default MachinesModalSettings
